import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { QualificationExportService } from '../../../service/qualification-export.service';

@Component({
  selector:
    'wilson-shared-user-qualifications-complementary-certificate-export-trigger',
  imports: [TranslatePipe, NzButtonModule],
  templateUrl:
    './shared-user-qualifications-complementary-certificate-export-trigger.component.html',
  styleUrl:
    './shared-user-qualifications-complementary-certificate-export-trigger.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUserQualificationsComplementaryCertificateExportTriggerComponent {
  private exportService = inject(QualificationExportService);

  exportSharedUserQualificationsComplementaryCertificate(): void {
    this.exportService.exportSharedUserQualificationsComplementaryCertificate();
  }
}
